import Vue from "vue";

export default {
  namespaced: true,
  state: {
    campaigns: null,
  },
  getters: {
    campaigns: (state) => state.campaigns,
  },
  mutations: {
    SET_CAMPAIGNS(state, payload) {
      state.campaigns = payload
    },
  },
  actions: {
    async loadCampaigns({commit}) {
      await Vue.axios.get('application/campaigns/')
        .then((response) => {
          commit('SET_CAMPAIGNS', response.data)
        })
    },
  }
}
